// https://support.trustpilot.com/hc/en-us/articles/115011421468--Add-a-TrustBox-widget-to-a-single-page-application#add-a-trustbox-widget-with-a-react-application-1
export default function TrustBox(props: { extraClassName?: string, templateId: string, height?: string }) {
    return (
        <div
            className={`trustpilot-widget ${props.extraClassName}`}
            data-locale="da-DK"
            data-template-id={props.templateId}
            data-businessunit-id="5687a64a0000ff0005872010"
            data-style-height={props.height}
            data-style-width="100%"
            data-theme="light"
            data-stars="4,5"
            data-review-languages="da"
            data-font-family="Montserrat"
            data-text-color="#303a4b"
        >
            <span/>
        </div>
    )
}
